import * as React from 'react';
import { StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import { Button, Theme } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import * as headerImage from '../images/wls_logo_new_small.png';
import { compose } from 'recompose';

interface Header {
    classes: any;
    children: Element;
}

// type ClassNames =
//     | 'root'
//     | 'appBar'
//     | 'logo';

const styles: StyleRulesCallback<Theme, any> = theme => ({
    root: {
        backgroundColor: theme.palette.primary.main
    },
    appBar: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignContent: 'flex-end'
    },
    logo: {
        margin: 20
    },
    logoContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'middle',
        width: '70%'
    },
    phoneContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    phoneNumber: {
        fontSize: 50,
        fontWeight: 'bold',
        color: 'white'
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end'
    },
    buttonStyle: {
        color: 'white'
    },
    '@media screen and (max-width: 768px)': {
        appBar: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            maxHeight: '100px',
        },
        phoneContainer: {

        },
        phoneNumber: {
            fontSize: 15,
            fontWeight: 'bold',
            color: 'white'
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'center'
        },
        buttonStyle: {
            margin: 0,

        },
        logo: {
            maxWidth: 200,
            marginTop: 10,
            marginBottom: 10,
            height: 'auto',
            width: 'auto'
        },
        logoContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
            width: '100%'
        },
    },
});

type HeaderProps =
    Header
    & WithStyles<typeof styles>
    & RouteComponentProps<{}>;

class Header extends React.Component<HeaderProps, {}> {

    render() {
        const {classes} = this.props as HeaderProps;
        return (
            <div
                className={classes.root}
            >
                <AppBar
                    elevation={5}
                    className={classes.appBar}
                >
                    <div
                        className={classes.logoContainer}
                    >
                        <img
                            className={classes.logo}
                            src={headerImage}
                            onClick={() => this.props.history.push(('/'))}
                        />
                        <div
                            className={classes.phoneContainer}
                        >
                            <Typography
                                className={classes.phoneNumber}
                            >
                                1-800-457-9571
                            </Typography>
                        </div>
                    </div>

                    <div
                        className={classes.buttonContainer}
                    >
                        <div>
                            <Button
                                onClick={() => this.props.history.push('/services')}
                                className={classes.buttonStyle}
                            >
                                Services
                            </Button>
                        </div>
                        <div>
                            <Button
                                onClick={() => this.props.history.push('/products')}
                                className={classes.buttonStyle}
                            >
                                Products
                            </Button>
                        </div>
                        <div>
                            <Button
                                onClick={() => this.props.history.push('/aboutus')}
                                className={classes.buttonStyle}
                            >
                                About Us
                            </Button>
                        </div>
                    </div>
                </AppBar>
            </div>
        );
    }
}

export default compose(withStyles(styles), withRouter)(Header) as any;
